import { Dispatch, SetStateAction, createContext } from 'react'
import { AuthState } from '../constants/auth'

export interface IAuthContext {
  authState: AuthState
  setAuthState: Dispatch<SetStateAction<AuthState>>
}

export const AuthContext = createContext<IAuthContext>(null!)